export const SET_USER = 'SET USER'
export const SET_CHARACTER = 'SETCHARACTER'
export const SET_TOKEN = 'SET TOKEN'
export const SET_ISLOGGED_IN = 'SET IS LOGGED IN'
export const CLEAR_DATA = 'CLEAR_DATA'